// Helpers puros dos gráficos da Análise de Estoque (linha expandida do produto).
// As datas vêm da API como "AAAA-MM-01T00:00:00Z" (mês da série): lemos o
// ano/mês do texto, sem passar por Date — em UTC−3, new Date('…-01T00:00:00Z')
// cai no mês anterior (regra do CLAUDE.md).

import type { ProductMonthlySales } from '../../types/stockAnalytics';

export const MONTH_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

/** "2026-10-01T00:00:00Z" → "2026-10"; texto fora do padrão devolve '' */
export function monthKeyFromIso(iso: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})/.exec(iso ?? '');
  return m ? `${m[1]}-${m[2]}` : '';
}

/** "2026-10" → "Out/26" */
export function monthLabelFromKey(key: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(key);
  if (!m) return key;
  const month = Number(m[2]);
  if (month < 1 || month > 12) return key;
  return `${MONTH_LABELS[month - 1]}/${m[1].slice(2)}`;
}

/** Chaves "AAAA-MM" dos últimos `count` meses, terminando no mês de `now` (inclusive), em ordem crescente. */
export function lastMonthKeys(count: number, now: Date): string[] {
  const keys: string[] = [];
  let y = now.getFullYear();
  let m = now.getMonth() + 1; // 1..12
  for (let i = 0; i < count; i++) {
    keys.unshift(`${y}-${String(m).padStart(2, '0')}`);
    m -= 1;
    if (m === 0) {
      m = 12;
      y -= 1;
    }
  }
  return keys;
}

export interface MonthlySeriesPoint {
  key: string;
  label: string;
  row: ProductMonthlySales | null; // null = mês sem linha na série (sem venda nem snapshot)
}

/**
 * Alinha a série mensal (que só tem linha nos meses com venda ou snapshot) na
 * janela dos últimos `count` meses, preenchendo os buracos com `row: null` —
 * assim o eixo não "pula" meses sem venda.
 */
export function alignMonthlySeries(series: ProductMonthlySales[] | null | undefined, count: number, now: Date): MonthlySeriesPoint[] {
  const byKey = new Map<string, ProductMonthlySales>();
  (series ?? []).forEach((row) => {
    const key = monthKeyFromIso(row.month_start);
    if (key) byKey.set(key, row);
  });
  return lastMonthKeys(count, now).map((key) => ({ key, label: monthLabelFromKey(key), row: byKey.get(key) ?? null }));
}
